import { Select, Tooltip } from "antd";
import { observer } from "mobx-react";
import { qaCategoriesStore } from "../Stores/QACategoriesStore";

interface QACategorySelectProps {
  defaultValue?: number;
  onChange?: (catId: number) => void;
  allowClear?: boolean;
  categories?: API_Category[];
}

export const QACategorySelect = observer(
  ({ defaultValue, onChange, allowClear, categories }: QACategorySelectProps) => {
    const changeCategory = async (value: number) => {
      try {
        if (value !== defaultValue) {
          onChange(value);
        }
      } catch (error) {
        throw error;
      }
    };

    const listedCategories = categories || qaCategoriesStore.activeCategories;
    return (
      <Select style={{ width: "100%" }} defaultValue={defaultValue} onSelect={changeCategory} allowClear={allowClear}>
        {listedCategories.map((item) => (
          <Select.Option key={`${item.id}`} value={item.id}>
            <Tooltip title={item.name} placement="left" align={{ offset: [-20, 0] }}>
              <>{item.name}</>
            </Tooltip>
          </Select.Option>
        ))}
      </Select>
    );
  }
);
